"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const report_processor_1 = require("./report-processor");
class OriginsProcessor extends report_processor_1.ReportProcessor {
    static decodeResponseData(responseData) {
        return {
            queryCount: responseData.query_count,
            origins: responseData.origins_data.map((origin) => OriginsProcessor.decodeOrigin(origin))
        };
    }
    static decodeOrigin(origin) {
        return {
            id: origin.origin,
            queryCount: origin.query_count,
            queryCountPct: origin.query_count_pct
        };
    }
    decodeStatsResponse(statsResponse) {
        const originsData = statsResponse.data.data;
        return {
            status: statsResponse.status,
            params: OriginsProcessor.decodeStatsParams(statsResponse.data.params),
            data: (!!originsData.length ? OriginsProcessor.decodeResponseData(originsData[0]) : {
                queryCount: 0,
                origins: []
            })
        };
    }
}
exports.OriginsProcessor = OriginsProcessor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JpZ2lucy5wcm9jZXNzb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvY2Vzc29ycy9vcmlnaW5zLnByb2Nlc3Nvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU1BLHlEQUFxRDtBQUVyRCxzQkFBOEIsU0FBUSxrQ0FBZTtJQUUzQyxNQUFNLENBQUMsa0JBQWtCLENBQUMsWUFBaUI7UUFDakQsTUFBTSxDQUFDO1lBQ0wsVUFBVSxFQUFFLFlBQVksQ0FBQyxXQUFXO1lBQ3BDLE9BQU8sRUFBRSxZQUFZLENBQUMsWUFBWSxDQUFDLEdBQUcsQ0FBQyxDQUFDLE1BQVcsRUFBRSxFQUFFLENBQUMsZ0JBQWdCLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1NBQy9GLENBQUM7SUFDSixDQUFDO0lBRU8sTUFBTSxDQUFDLFlBQVksQ0FBQyxNQUFXO1FBQ3JDLE1BQU0sQ0FBQztZQUNMLEVBQUUsRUFBRSxNQUFNLENBQUMsTUFBTTtZQUNqQixVQUFVLEVBQUUsTUFBTSxDQUFDLFdBQVc7WUFDOUIsYUFBYSxFQUFFLE1BQU0sQ0FBQyxlQUFlO1NBQ3RDLENBQUM7SUFDSixDQUFDO0lBRU0sbUJBQW1CLENBQUMsYUFBNEI7UUFDckQsTUFBTSxXQUFXLEdBQUcsYUFBYSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDNUMsTUFBTSxDQUFDO1lBQ0wsTUFBTSxFQUFFLGFBQWEsQ0FBQyxNQUFNO1lBQzVCLE1BQU0sRUFBRSxnQkFBZ0IsQ0FBQyxpQkFBaUIsQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztZQUNyRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsZ0JBQWdCLENBQUMsa0JBQWtCLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUNsRixVQUFVLEVBQUUsQ0FBQztnQkFDYixPQUFPLEVBQUUsRUFBRTthQUNaLENBQUM7U0FDSCxDQUFDO0lBQ0osQ0FBQztDQUVGO0FBN0JELDRDQTZCQyJ9